export default __webpack_public_path__ + "static/media/Bug--TrackerLogo(bug).31212c61.svg";